import { render } from "./DefaultDiamond.vue?vue&type=template&id=5d4bf5ea&scoped=true"
import script from "./DefaultDiamond.vue?vue&type=script&lang=js"
export * from "./DefaultDiamond.vue?vue&type=script&lang=js"

import "./DefaultDiamond.vue?vue&type=style&index=0&id=5d4bf5ea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4bf5ea"]])

export default __exports__